export default __webpack_public_path__ + "static/mvtec-hdevelopevo-d6ca827c9aca083d8af575e2d939a573.png";